import React, { useEffect, useLayoutEffect, useRef, useState } from "react"
import { createPortal } from "react-dom"
import { motion } from "framer-motion"

// Всплывающая панель у якорного элемента. Рендерится через портал в корень приложения,
// чтобы не обрезаться overflow-x у таблицы (корень сохраняет tailwind-scope).
const FloatingPanel = ({ anchorEl, onClose, width = 300, children }) => {
  const ref = useRef(null)
  const [pos, setPos] = useState(null)
  const w = Math.min(width, window.innerWidth - 16) // на мобильных не шире экрана

  useLayoutEffect(() => {
    if (!anchorEl || !ref.current) return
    const r = anchorEl.getBoundingClientRect()
    const h = ref.current.offsetHeight
    const left = Math.min(Math.max(8, r.left + r.width / 2 - w / 2), window.innerWidth - w - 8)
    const below = r.bottom + 6
    const above = r.top - h - 6
    const top = below + h > window.innerHeight - 8 && above > 8 ? above : below
    setPos({ left, top })
  }, [anchorEl, w, children])

  useEffect(() => {
    const onDown = (e) => {
      if (ref.current?.contains(e.target) || anchorEl?.contains(e.target)) return
      onClose()
    }
    const onScroll = (e) => {
      if (ref.current?.contains(e.target)) return
      onClose()
    }
    const onKey = (e) => e.key === "Escape" && onClose()

    document.addEventListener("mousedown", onDown)
    document.addEventListener("keydown", onKey)
    window.addEventListener("scroll", onScroll, true)
    window.addEventListener("resize", onClose)
    return () => {
      document.removeEventListener("mousedown", onDown)
      document.removeEventListener("keydown", onKey)
      window.removeEventListener("scroll", onScroll, true)
      window.removeEventListener("resize", onClose)
    }
  }, [anchorEl, onClose])

  const root = document.getElementById("transfer-prices-grid") || document.body

  return createPortal(
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: -4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.15 }}
      style={{
        position: "fixed",
        left: pos?.left ?? 0,
        top: pos?.top ?? 0,
        width: w,
        visibility: pos ? "visible" : "hidden",
        zIndex: 9999,
      }}
      className="bg-white rounded-card border border-app-content-faint/20 shadow-lg overflow-hidden isolate"
    >
      {children}
    </motion.div>,
    root
  )
}

export default FloatingPanel
